var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-center mt-8"},[_c('v-alert',{attrs:{"dense":"","outlined":"","type":"error"}},[_vm._v(" Leider ist etwas schief gelaufen, bitte versuchen Sie es zu einem späteren Zeitpunkt erneut. ")]),_c('v-btn',{attrs:{"color":"primary","to":"/auth/login"}},[_vm._v(" Zurück zum Login ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }